let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4d5G8")).then(() => parcelRequire('t5NgT'));